import {Button, Divider, Layout, Tabs, Typography} from 'antd';
import {React, useState} from 'react';
import appColors from '../../style/theme';
import AP from './AP';
import BANWB from './BANWB';
import EAUNP from './EAUNP';
import ModWL from './ModWL';

const {Paragraph, Text} = Typography;
const Content = Layout;

const ModWLTabs = () => {
  const [TAUno, setTAUno] = useState('white');
  const [GAUno, setGAUno] = useState(appColors['ColorX']);
  // others
  const [TUno, setTUno] = useState(appColors['ColorX']);
  const [GUno, setGUno] = useState(appColors['ColorG2']);
  const [Tno, setTno] = useState(appColors['ColorX']);
  const [Gno, setGno] = useState(appColors['ColorG2']);
  const [To, setTo] = useState(appColors['ColorX']);
  const [Go, setGo] = useState(appColors['ColorG2']);

  const changeColor1 = (key) => {
    if (key === 'uno') {
      setTAUno('white');
      setGAUno(appColors['ColorX']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
    } else if (key === 'dos') {
      setTUno('white');
      setGUno(appColors['ColorX']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
    } else if (key === 'tres') {
      setTno('white');
      setGno(appColors['ColorX']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
    } else if (key === 'cuatro') {
      setTo('white');
      setGo(appColors['ColorX']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
    }
  };
  const items_ = [
    {label: <Button style={{width: '20vh', height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TAUno, fontWeight: 'bold', borderColor: GAUno, background: GAUno}}>AuNPs<br/>Conjugation</Button>, key: 'uno', children: <ModWL/>},
    {label: <Button style={{width: '20vh', height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TUno, fontWeight: 'bold', borderColor: GUno, background: GUno}}>Electrophoresis<br/> gel with AuNPs</Button>, key: 'dos', children: <EAUNP/>},
    {label: <Button style={{width: '22vh', height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: Tno, fontWeight: 'bold', borderColor: Gno, background: Gno}}>Interaction of<br/>biotin-streptavidin</Button>, key: 'tres', children: <AP/>},
    {label: <Button style={{width: '20vh', height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: To, fontWeight: 'bold', borderColor: Go, background: Go}}>Binding<br/>aptamers to<br/>nitrocellulose</Button>, key: 'cuatro', children: <BANWB/>},
  ];
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3' style={{color: appColors['ColorX']}}>Modifications of the aptamers</Paragraph>
        <Text className='BaseText2'>The second phase of our experimental pipeline was to prove that the modifications done on the aptamers work well. We wanted to know if the aptamers modified in the extreme with thiol or biotin bind correctly with the AuNPs and the streptavidin.</Text>
      </Content>
      <Content style={{padding: '2vh', background: 'transparent'}}>
        <Tabs
          tabBarGutter='3vh'
          defaultActiveKey="1"
          size='large'
          items={items_}
          onTabClick={changeColor1}
        />
      </Content>
      <Divider/>
    </Layout>
  );
};

export default ModWLTabs;
